module.exports = __webpack_public_path__ + "img/about-category-bg@mb.2c866f1.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-category-bg@mb.svg
// module id = 6S1u
// module chunks = 2